import React from 'react';
import * as Yup from 'yup';
import SelectFunctionalTitles from '@molecules/SelectFunctionalTitles';

export const editProfileEmploymentValidationSchema = {
    functionalTitle: Yup.string(),
};

const EditProfileFieldsEmployment = () => (
    <>
        <SelectFunctionalTitles />
    </>
);

export default EditProfileFieldsEmployment;
